<template>
  <BModal v-model="showModalInternal" title="Szczegóły uprawnienia" hide-footer scrollable>
    <div v-if="privilege">
      <div class="card shadow-sm mb-3">
        <div class="card-header bg-light">
          <h6 class="mb-0 text-primary fw-bold">
            <i class="fas fa-info-circle me-2"></i>Informacje o uprawnieniu
          </h6>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-4">
              <label class="form-label text-muted small">ID</label>
              <input type="text" class="form-control" :value="privilege.id || '-'" disabled />
            </div>
            <div class="col-md-8">
              <label class="form-label text-muted small">Nazwa (klucz)</label>
              <input
                type="text"
                class="form-control"
                :value="privilege.name || privilege.key || privilege.privilegeKey || '-'"
                disabled
              />
            </div>
            <div class="col-12">
              <label class="form-label text-muted small">Nazwa wyświetlana</label>
              <input
                type="text"
                class="form-control"
                :value="privilege.displayName || '-'"
                disabled
              />
            </div>
            <div class="col-12">
              <label class="form-label text-muted small">Opis</label>
              <textarea
                class="form-control"
                rows="3"
                :value="privilege.description || privilege.details || '-'"
                disabled
              ></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="text-muted fst-italic mb-3">Brak danych uprawnienia.</div>

    <div class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" @click="showModalInternal = false">
        Zamknij
      </button>
    </div>
  </BModal>
</template>

<script>
import { BModal } from "bootstrap-vue-next";

export default {
  name: "PrivilegeDetailsModal",
  components: { BModal },
  props: {
    showModal: { type: Boolean, required: true },
    privilege: { type: Object, default: () => null },
  },
  emits: ["update:showModal"],
  data() {
    return {
      showModalInternal: this.showModal,
    };
  },
  watch: {
    showModal(newValue) {
      this.showModalInternal = newValue;
    },
    showModalInternal(newValue) {
      this.$emit("update:showModal", newValue);
    },
  },
};
</script>
